import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TrackingType } from '@/lib/type/type';

interface StateStore {
    deliveryDetail: TrackingType | null;
}

const initialState: StateStore = {
    deliveryDetail: null,
};

const parcelTracking = createSlice({
    name: 'tracking',
    initialState,
    reducers: {
        getTrackNumber: (state, action: PayloadAction<TrackingType>) => {
            state.deliveryDetail = action.payload;
        },
    },
});

export const { getTrackNumber } = parcelTracking.actions;
export default parcelTracking.reducer;
